const COLUMNS = 'columns';
const EXPORT = 'export';
const CURRENCY = 'currency';

export const tableActions = { COLUMNS, EXPORT, CURRENCY };
